import { createSlice } from '@reduxjs/toolkit';
import { BrokerReducer } from '../../reducers/BrokerReducer';
import { IBroker } from '../../../broker/interfaces/IBroker';

const initialState: IBroker = {};

export const brokerSlice = createSlice({
	name: 'broker',
	initialState,
	reducers: BrokerReducer,
});

export const { setBroker, updateIpafInProgress, setNeedsBankInfo, setLogo } =
	brokerSlice.actions;

export default brokerSlice.reducer;
